export default "__VITE_ASSET__D5DVcr8K__"